import React from "react";
import { MdDashboard } from "react-icons/md";

export default function AdminLoadingState() {
  return (
    <div className="flex min-h-[360px] items-center justify-center px-4">
      <div className="w-full max-w-md rounded-[2rem] border border-slate-200 bg-white p-6 text-center shadow-xl dark:border-slate-800 dark:bg-slate-900">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-50 text-2xl text-sky-600 dark:bg-sky-500/10 dark:text-sky-300">
          <MdDashboard />
        </div>

        <h2 className="mt-4 text-lg font-bold text-slate-900 dark:text-white">
          Chargement de votre espace
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          Nous vérifions vos autorisations pour afficher uniquement les modules
          auxquels vous avez accès.
        </p>

        <div className="mt-5 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-gradient-to-r from-sky-500 to-cyan-400" />
        </div>
      </div>
    </div>
  );
}